function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { createRef } from "react";
import SocialTopics from "../containers/SocialTopics";
import SocialActivityEditor from "../containers/SocialActivityEditor";
import SocialTopic from "./SocialTopic";
import SocialSphereSelector from "../containers/SocialSphereSelector";
import SocialAppHeader from "./SocialAppHeader";
import SocialAppFooter from "./SocialAppFooter";
import SocialAppModal from "./SocialAppModal.react.js";
import ErrorBoundary from "./ErrorBoundary";
import Icon from "./Icon";
import isEqual from "lodash/isEqual";
import map from "lodash/map";
import clone from "lodash/clone";
import eventBus from "../utils/eventBus";
import { CSSTransition } from "react-transition-group";
import { injectIntl } from "react-intl";
import { getConnectionStatus } from "../utils/SocialConnectionsUtils";
import { FocusOn } from "react-focus-on";
import { EventEmitter } from "events";
import UIToggleButton from "./ui/UIToggleButton";
// Constants
var VIEW_SIGNED_OUT = "SIGNED OUT";
var VIEW_TOPICS = "TOPICS";
var VIEW_ACTIVITIES = "ACTIVITIES";
var MODAL_SPHERES = "SPHERE SELECTOR";
var MODAL_TOPIC = "TOPIC EDITOR";
var MODAL_DISCLAIMER = "DISCLAIMER";
var MODAL_SHARE = "TOPIC SHARE";
var NODE_FILTER_TYPES = {
    CBOOK: "cbook",
    CURRENT_CHART: "current_chart"
};
var SocialNotesApp = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(SocialNotesApp, _React_Component);
    var _super = _createSuper(SocialNotesApp);
    function SocialNotesApp(props) {
        _classCallCheck(this, SocialNotesApp);
        var _this;
        _this = _super.call(this, props);
        _this.renderTopics = function() {
            var _this_props = _this.props, intl = _this_props.intl, currentOnly = _this_props.currentOnly, noteGroup = _this_props.noteGroup;
            var showFromAllCBook = _this.state.currentNodeFilter === NODE_FILTER_TYPES.CBOOK;
            var currentFilter = showFromAllCBook ? intl.formatMessage({
                id: "social.activities._title_nodes_filter_cbook",
                defaultMessage: "cbook"
            }) : intl.formatMessage({
                id: "social.activities._title_nodes_filter_current_chart",
                defaultMessage: "current slide"
            });
            return {
                body: noteGroup ? /*#__PURE__*/ React.createElement(SocialTopics, {
                    className: "social-app-body__wrapper",
                    sphere: noteGroup,
                    isNotes: true,
                    onCreate: _this._onCreateNote,
                    onSelect: _this._onSelectNote,
                    noteFilter: _this._getNodesForFilter(_this.state.currentNodeFilter),
                    selectNote: _this.props.selectNote,
                    selectTopic: _this.props.selectTopic
                }) : null,
                header: {
                    content: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
                        className: "social-app-title",
                        id: "notes-header"
                    }, intl.formatMessage({
                        id: "social.notes.title",
                        defaultMessage: "Notes"
                    })), !currentOnly && /*#__PURE__*/ React.createElement(UIToggleButton, {
                        id: "filter-notes",
                        onToggle: _this.handleNodeFilterChanged,
                        pressed: showFromAllCBook,
                        label: intl.formatMessage({
                            id: "social.activities._title_nodes_filter_label",
                            defaultMessage: "Showing from: {currentFilter}"
                        }, {
                            currentFilter: currentFilter
                        })
                    }, /*#__PURE__*/ React.createElement(Icon, {
                        name: showFromAllCBook ? "pages-all" : "page-current",
                        size: "m"
                    }), /*#__PURE__*/ React.createElement("span", {
                        className: "ui-toggle-text"
                    }, currentFilter))),
                    hero: true
                }
            };
        };
        _this.renderActivities = function() {
            var _this_state_selectedNote;
            var intl = _this.props.intl;
            return {
                body: /*#__PURE__*/ React.createElement(SocialTopic, {
                    className: "social-app-body__wrapper",
                    topic: _this.state.selectedNote,
                    isEditable: true,
                    isNote: true,
                    onShare: _this._onShare,
                    onDeleteTopic: _this._onDeleteNote,
                    onEditTopic: _this._onEditNote,
                    session: _this.props.session
                }),
                header: {
                    content: /*#__PURE__*/ React.createElement("ul", {
                        className: "social-breadcrumb"
                    }, /*#__PURE__*/ React.createElement("li", {
                        className: "social-breadcrumb__item"
                    }, /*#__PURE__*/ React.createElement("button", {
                        className: "social-breadcrumb__link",
                        onClick: _this._onHome,
                        "aria-label": intl.formatMessage({
                            id: "social.notes.see_all_notes",
                            defaultMessage: "See all notes"
                        })
                    }, /*#__PURE__*/ React.createElement(Icon, {
                        name: "social-breadcrumb-home",
                        size: "m"
                    }))), /*#__PURE__*/ React.createElement(Icon, {
                        name: "chevron-right",
                        size: "s",
                        className: "social-breadcrumb__separator"
                    }), /*#__PURE__*/ React.createElement("li", {
                        className: "social-breadcrumb__item"
                    }, (_this_state_selectedNote = _this.state.selectedNote) === null || _this_state_selectedNote === void 0 ? void 0 : _this_state_selectedNote.title))
                }
            };
        };
        _this.renderSignedOut = function() {
            var intl = _this.props.intl;
            var status = getConnectionStatus("tweet");
            var isError = status > 399;
            return {
                header: {
                    content: /*#__PURE__*/ React.createElement("div", {
                        className: "social-app__error-header"
                    }, isError ? intl.formatMessage({
                        id: "social.activities.errorHeader",
                        defaultMessage: "error with status {status}"
                    }, {
                        status: status
                    }) : intl.formatMessage({
                        id: "social.activities._signed_out",
                        defaultMessage: "signed out"
                    }))
                },
                body: /*#__PURE__*/ React.createElement("div", {
                    className: "social-app__signed-out"
                }, !_this.state.offline ? /*#__PURE__*/ React.createElement("p", null, status > 403 ? intl.formatMessage({
                    id: "social.activities.errorMsg",
                    defaultMessage: "error with status: {status}"
                }, {
                    status: status
                }) : intl.formatMessage({
                    id: "social.activities._signed_out",
                    defaultMessage: "signed out"
                })) : /*#__PURE__*/ React.createElement("p", null, intl.formatMessage({
                    id: "social.activities._server_offline",
                    defaultMessage: "offline"
                })))
            };
        };
        _this._onNoteChange = function() {
            // this.forceUpdate();
            var notes = _this.props.notes;
            if (_this.state.selectedNote) {
                var updatedNote = notes[_this.state.selectedNote.id];
                _this.setState({
                    selectedNote: updatedNote || null
                });
            // console.log(
            //   this.state.selectedNote.id ? notes[this.state.selectedNote.id] : null,
            // );
            } else {
                _this.forceUpdate(); // TO DO: What is this supposed to do regarding whether or not a selectedNote is currently in the state?
            }
        };
        _this._onSearchedTopicSelect = function(note, app) {
            if (app === "Note") {
                _this.searchTopic = true;
                _this.setState({
                    currentView: VIEW_ACTIVITIES,
                    selectedNote: note
                });
            }
        };
        _this._onToggleCreateTopic = function(isEditing) {
            _this.setState({
                isCreatingTopic: isEditing
            });
        };
        _this._onSelectNote = function(note) {
            _this.setState({
                currentView: VIEW_ACTIVITIES,
                selectedNote: note
            });
        };
        _this._onEditNote = function() {
            _this.setState({
                modalView: MODAL_TOPIC,
                editableTopic: _this.state.selectedNote
            });
        };
        _this._onShowNotes = function() {
            _this.props.selectTopic(null);
            _this.setState({
                currentView: VIEW_TOPICS,
                selectedNote: null
            });
        };
        _this._onCreateNote = function() {
            _this.setState({
                modalView: MODAL_TOPIC
            });
        };
        _this._onDeleteNote = function(topic) {
            var _this_props = _this.props, intl = _this_props.intl, sendAlert = _this_props.sendAlert, deleteNote = _this_props.deleteNote;
            deleteNote(topic, _this.state.selectedCbookNodes.map(function(id) {
                return {
                    id: id
                };
            }));
            _this._onShowNotes();
        };
        _this._topicEditorAction = function(action) {
            var self = _assertThisInitialized(_this);
            return function() {
                self.state.topicEditorAction.emit("action", action);
            };
        };
        _this.handleNodeFilterChanged = function(pressed) {
            var currentNodeFilter = pressed ? NODE_FILTER_TYPES.CBOOK : NODE_FILTER_TYPES.CURRENT_CHART;
            var nodes = _this._getNodesForFilter(currentNodeFilter);
            _this._updateSearchFilter(nodes);
            _this.setState({
                currentNodeFilter: currentNodeFilter
            });
        };
        _this._getNodesForFilter = function(filterValue) {
            var currentSlide = _this.props.currentSlide;
            switch(filterValue){
                case NODE_FILTER_TYPES.CBOOK:
                    return []; // TO DO: Why is this an empty array?
                case NODE_FILTER_TYPES.CURRENT_CHART:
                    return currentSlide ? [
                        currentSlide
                    ] : [];
                default:
                    return [];
            }
        };
        _this._updateSearchFilter = function(nodes) {
            _this.setState({
                selectedCbookNodes: nodes
            });
        };
        // =========================================================
        //        SOCIAL SPHERE SPECIFIC
        // =========================================================
        _this._onSocialSpheresLoaded = function() {
            var nodes = _this._getNodesForFilter(_this.state.currentNodeFilter);
            _this._updateSearchFilter(nodes);
        };
        // =========================================================
        //        APP SPECIFIC
        // =========================================================
        _this._onSessionChange = function() {
            var _this_props = _this.props, session = _this_props.session, socialConfig = _this_props.socialConfig;
            var signedOut = session === null;
            // Update State to change the view, when necessary
            _this.setState({
                modalView: !!session && !!socialConfig && !!(socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.disclaimer.needs_endorsement) && !(session === null || session === void 0 ? void 0 : session.is_disclaimer_endorsed) ? MODAL_DISCLAIMER : null,
                loggedIn: !!session && !!(socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.disclaimer.needs_endorsement) && !session.is_disclaimer_endorsed ? false : !!session,
                currentView: signedOut ? VIEW_SIGNED_OUT : _this.state.currentView === VIEW_SIGNED_OUT ? VIEW_TOPICS : _this.state.currentView
            });
        };
        _this._onToggleNotesApp = function() {
            var self = _assertThisInitialized(_this);
            return function(evnt) {
                evnt.preventDefault();
                evnt.currentTarget.blur();
                self.props.onToggleNotesApp(); // TO DO: this prop isn't actively passed to SocialNotesApp anywhere in the entire cBook player...?
            };
        };
        _this.handleCancelModal = function() {
            _this.setState({
                modalView: null,
                editableSphere: null,
                editableTopic: null
            });
        };
        _this._onTopics = function(evnt) {
            evnt.preventDefault();
            _this._onShowNotes();
        };
        _this._onHome = function(evnt) {
            evnt.preventDefault();
            _this.setState({
                selectedNote: null,
                modalView: null,
                editableSphere: null,
                editableTopic: null,
                currentView: VIEW_TOPICS
            });
        };
        _this._onConnectionUpdate = function(connection) {
            // TODO: Sensible status messages, and what happens for which status code?
            // console.log('connection', connection);
            if (!connection) {
                return;
            }
            var status = getConnectionStatus("tweet");
            console.log(">>> STATUS from connection update notes app: " + status);
            if (status === 0 && !_this.state.offline) {
                _this.setState({
                    offline: true
                });
            }
            if (status > 0) {
                _this.setState({
                    offline: !_this.state.offline,
                    currentView: status > 399 && _this.state.currentView !== VIEW_SIGNED_OUT ? VIEW_SIGNED_OUT : _this.state.currentView
                });
            }
        };
        _this._acceptDisclaimer = function(evnt) {
            evnt.preventDefault();
            _this.props.acceptDisclaimer();
        };
        _this._onShare = function(topic) {
            _this.setState({
                shareable: topic,
                modalView: MODAL_SPHERES
            });
        };
        _this._onSelectSphere = function(sphere) {
            var _shareable = clone(_this.state.shareable);
            _shareable.sphere = sphere;
            _this.setState({
                shareable: _shareable,
                modalView: MODAL_SHARE
            });
        };
        _this._shareEditorAction = function(action) {
            var self = _assertThisInitialized(_this);
            return function() {
                self.state.sharedEditorAction.emit("action", action);
            };
        };
        _this.closeButton = /*#__PURE__*/ createRef();
        _this.searchTopic = false;
        _this.state = {
            currentView: VIEW_SIGNED_OUT,
            modalView: null,
            loggedIn: false,
            offline: false,
            selectedNote: null,
            searchedTopicID: null,
            isEditingSphere: false,
            isCreatingTopic: false,
            editableTopic: null,
            editableSphere: null,
            shareable: null,
            topicEditorAction: new EventEmitter(),
            sharedEditorAction: new EventEmitter(),
            activityEditorAction: new EventEmitter(),
            // Node Selection (needed for feature "show notes for current chart or for entire cBook"):
            currentNodeFilter: NODE_FILTER_TYPES.CURRENT_CHART,
            selectedCbookNodes: _this._getNodesForFilter(NODE_FILTER_TYPES.CURRENT_CHART)
        };
        return _this;
    }
    var _proto = SocialNotesApp.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // Info: Log in & loading of initial data from engagement server happens inside of ChartRenderer
        this._onSessionChange();
        eventBus.register("Escape", "notes-app", this.props.close);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.state.topicEditorAction) {
            this.state.topicEditorAction.removeAllListeners();
        }
        if (this.state.activityEditorAction) {
            this.state.activityEditorAction.removeAllListeners();
        }
        eventBus.unregister("Escape", "notes-app");
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this_props = this.props, visible = _this_props.visible, currentSlide = _this_props.currentSlide, currentOnly = _this_props.currentOnly, session = _this_props.session, searchedTopics = _this_props.searchedTopics, notes = _this_props.notes, fetchNotes = _this_props.fetchNotes, noteGroup = _this_props.noteGroup, connections = _this_props.connections, currentSearch = _this_props.currentSearch, isDeletingNote = _this_props.isDeletingNote, deletingNoteError = _this_props.deletingNoteError, sendAlert = _this_props.sendAlert, intl = _this_props.intl;
        var _this_state = this.state, loggedIn = _this_state.loggedIn, currentNodeFilter = _this_state.currentNodeFilter, selectedCbookNodes = _this_state.selectedCbookNodes, modalView = _this_state.modalView;
        if (!isEqual(prevProps.currentSearch, currentSearch)) {
            this._onSearchedTopicSelect(currentSearch.topic, currentSearch.app);
        }
        if (prevProps.isDeletingNote && !isDeletingNote && !deletingNoteError) {
            sendAlert(intl.formatMessage({
                id: "social.notes.note_deleted",
                defaultMessage: "deleted Note"
            }), "success");
        }
        // reload notes if these conditions are met
        if (!!loggedIn && (!isEqual(noteGroup, prevProps.noteGroup) || !isEqual(visible, prevProps.visible) && !!visible || !isEqual(selectedCbookNodes, prevState.selectedCbookNodes) || !isEqual(modalView, prevState.modalView) && !modalView || prevProps.currentSlide !== currentSlide)) {
            if (noteGroup) {
                var nodes = map(selectedCbookNodes, function(nodeId) {
                    return {
                        id: nodeId
                    };
                });
                fetchNotes(noteGroup, nodes);
            } else {
                console.warn("cannot fetch notes because note group is undefined");
            }
        }
        if (!isEqual(prevProps.connections, connections) && connections.tweet) {
            this._onConnectionUpdate(connections.tweet);
        }
        if (currentOnly !== prevProps.currentOnly && currentOnly) {
            this.setState({
                currentNodeFilter: NODE_FILTER_TYPES.CURRENT_CHART
            });
        }
        if (prevProps.currentSlide !== currentSlide && loggedIn) {
            var nodes1 = this._getNodesForFilter(currentNodeFilter);
            this._updateSearchFilter(nodes1);
        }
        if (prevProps.visible !== visible && visible) {
            eventBus.setScope("notes-app");
        }
        if (prevProps.visible !== visible && !visible) {
            eventBus.usePrevScope();
        }
        if (!isEqual(prevProps.session, session)) {
            this._onSessionChange();
        }
        if (prevProps.isLoadingGroups && !this.props.isLoadingGroups) {
            this._onSocialSpheresLoaded();
        }
        if (this.state.selectedNote && !isEqual(prevProps.notes[this.state.selectedNote.id], notes[this.state.selectedNote.id])) {
            this._onNoteChange();
        }
        if (prevProps.isAcceptingDisclaimer !== this.props.isAcceptingDisclaimer && !this.props.isAcceptingDisclaimer && !this.props.acceptDisclaimerError) {
            this._onSessionChange();
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, visible = _this_props.visible, intl = _this_props.intl, close = _this_props.close, noteGroup = _this_props.noteGroup, cbook = _this_props.cbook, socialConfig = _this_props.socialConfig;
        var view, modalBody;
        var editableTopic;
        var disclaimerText = cbook && socialConfig ? socialConfig.disclaimer.languages[cbook.default_ui_language] || "There is no disclaimer for this language." : "cBook or socialConfig data not available.";
        switch(this.state.currentView){
            case VIEW_ACTIVITIES:
                view = this.renderActivities();
                break;
            case VIEW_SIGNED_OUT:
                view = this.renderSignedOut();
                break;
            default:
                view = this.renderTopics();
                break;
        }
        switch(this.state.modalView){
            case MODAL_TOPIC:
                editableTopic = this.state.editableTopic;
                modalBody = /*#__PURE__*/ React.createElement(SocialActivityEditor, {
                    sphere: noteGroup,
                    className: "social-app-modal__wrapper",
                    isNote: true,
                    isTopic: true,
                    activity: editableTopic ? editableTopic.description : {},
                    topic: editableTopic || {},
                    action: this.state.topicEditorAction,
                    onSaved: this.handleCancelModal
                });
                view.header = {
                    content: editableTopic ? intl.formatMessage({
                        id: "social.notes.edit_note",
                        defaultMessage: "edit note"
                    }) : intl.formatMessage({
                        id: "social.notes.new_note",
                        defaultMessage: "new note"
                    }),
                    buttons: {
                        leftButton: {
                            action: this.handleCancelModal
                        },
                        rightButton: {
                            action: this._topicEditorAction("save")
                        }
                    }
                };
                break;
            case MODAL_DISCLAIMER:
                modalBody = /*#__PURE__*/ React.createElement("div", {
                    className: "social-app-disclaimer",
                    dangerouslySetInnerHTML: {
                        __html: disclaimerText
                    }
                });
                view.header = {
                    content: intl.formatMessage({
                        id: "social.activities.disclaimer",
                        defaultMessage: "Disclaimer"
                    }),
                    buttons: {
                        rightButton: {
                            action: this._acceptDisclaimer,
                            title: intl.formatMessage({
                                id: "social.activities.accept_disclaimer",
                                defaultMessage: "accept"
                            })
                        }
                    }
                };
                break;
            case MODAL_SPHERES:
                modalBody = /*#__PURE__*/ React.createElement(SocialSphereSelector, {
                    className: "social-app-modal__wrapper",
                    onSelect: this._onSelectSphere
                });
                view.header = {
                    content: intl.formatMessage({
                        id: "social.notes.share_sphere_title",
                        defaultMessage: "share sphere"
                    }),
                    buttons: {
                        leftButton: {
                            action: this.handleCancelModal
                        }
                    }
                };
                break;
            case MODAL_SHARE:
                editableTopic = this.state.shareable;
                modalBody = /*#__PURE__*/ React.createElement(SocialActivityEditor, {
                    className: "social-app-modal__wrapper",
                    sphere: editableTopic === null || editableTopic === void 0 ? void 0 : editableTopic.sphere,
                    isNote: true,
                    isTopic: true,
                    activity: editableTopic ? editableTopic.description : {},
                    topic: editableTopic || {},
                    action: this.state.sharedEditorAction,
                    onSaved: this.handleCancelModal,
                    duplicate: editableTopic
                });
                view.header = {
                    content: intl.formatMessage({
                        id: "social.notes.share",
                        defaultMessage: "share"
                    }),
                    buttons: {
                        leftButton: {
                            action: this.handleCancelModal
                        },
                        rightButton: {
                            action: this._shareEditorAction("save"),
                            title: intl.formatMessage({
                                id: "social.notes.share",
                                defaultMessage: "share"
                            })
                        }
                    }
                };
                break;
            default:
                break;
        }
        return /*#__PURE__*/ React.createElement(CSSTransition, {
            in: visible,
            timeout: 300,
            classNames: "social-app"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "social-app social-app--notes"
        }, /*#__PURE__*/ React.createElement(ErrorBoundary, null, /*#__PURE__*/ React.createElement(FocusOn, {
            enabled: visible,
            onActivation: function() {
                var _this_closeButton, _this_closeButton_current;
                return (_this_closeButton = _this.closeButton) === null || _this_closeButton === void 0 ? void 0 : (_this_closeButton_current = _this_closeButton.current) === null || _this_closeButton_current === void 0 ? void 0 : _this_closeButton_current.focus();
            },
            className: "social-app-wrapper",
            noIsolation: true,
            autoFocus: true
        }, /*#__PURE__*/ React.createElement("button", {
            className: "close-btn",
            onClick: close,
            ref: this.closeButton,
            "aria-label": intl.formatMessage({
                id: "ui.close_dialog",
                defaultMessage: "Close dialog"
            })
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "close-socialmenu",
            size: "s"
        })), /*#__PURE__*/ React.createElement(SocialAppHeader, {
            hero: view.header.hero
        }, view.header.content), /*#__PURE__*/ React.createElement("div", {
            className: "social-app-body"
        }, view.body), /*#__PURE__*/ React.createElement(SocialAppModal, {
            visible: !!this.state.modalView
        }, modalBody), /*#__PURE__*/ React.createElement(SocialAppFooter, {
            hero: view.header.hero,
            buttons: view.header.buttons,
            id: "notes-header"
        })))));
    };
    return SocialNotesApp;
}(React.Component);
export default injectIntl(SocialNotesApp);
